/**
 * Locale readiness for person content — mirrors attraction locale statuses.
 */
export enum PersonLocaleStatusEnum {
    EMPTY = 'empty',
    GENERATED = 'generated',
    REVIEWED = 'reviewed',
}
